import { render, staticRenderFns } from "./PupilMove.vue?vue&type=template&id=b00987fa&scoped=true&"
import script from "./PupilMove.vue?vue&type=script&lang=js&"
export * from "./PupilMove.vue?vue&type=script&lang=js&"
import style0 from "./PupilMove.vue?vue&type=style&index=0&id=b00987fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00987fa",
  null
  
)

export default component.exports